// IMPORTS
// Modules
import $ from 'jquery';
// OHS
import { OHSListDataFormatter } from '../../../../../onehivesystems/js/OHSList';
import { OHSFormItem, OHSFormSubmit, OHSFormSelectBuilder } from '../../../../../onehivesystems/js/OHSForm';
import OHSCRUD from '../../../../../onehivesystems/js/OHSCRUD';
// Assets
import { portModel } from '../_variables';


// COMPONENT
export default function PortTemplates (props) {
   // Functions
   const applyPortTemplate = function () {
      OHSCRUD({
         url: '/v1/oneport/ports/applytemplate/' + props.parent.content.id.value,
         method: 'PUT',
         payload: JSON.stringify({
            'porttemplate_id': $('#oneport-port-' + props.parent.index + '-porttemplate').val()
         }),
         success: function (data) {
            var temp = props.parent.ports;
            temp[props.parent.index] = OHSListDataFormatter(data[0], portModel);
            props.parent.setPorts(temp);
            props.parent.setPortStatus(props.parent.getPortStatus(temp[props.parent.index]));
            props.parent.hidePopup(props.parent.index);
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true,
         setOHSConfirmation: props.onehive.setConfirmation,
         confirmMessage: "Are you sure you wish to apply this port template? Doing so will overwrite all information in the fields of this port."
      });
   }

   // Component
   return (
      <div>
         <OHSFormItem onehive={props.onehive} title="Port Template">
            <OHSFormSelectBuilder onehive={props.onehive} id={`oneport-port-${props.parent.index}-porttemplate`} content={props.parent.portTemplates} field={"name"} blank={false} />
         </OHSFormItem>
         <OHSFormSubmit onehive={props.onehive} custom={[
            {
               title: "Apply Port Template",
               action: applyPortTemplate,
               class: "ohsbtn"
            }
         ]} />
      </div>
   );
}